import { ButtonApplyJob } from "../../common/components/controls/button/buttonApplyJob";
import { LoadingPage } from "../../common/components/loading/loadingPage";
import { ErrorPage } from "../../common/components/template_page/errorPage";
import { textChooser } from "../../common/util/textChooser";
import { levelExpertise } from "../../common/util/GlobalData";
import { NumericFormat } from "react-number-format";
import { Dot } from "../../common/components/dot";
import { useOpportunity } from "../../common/hooks/Opportunities";
import { OpportunityContainer, OpportunityDescription, RequirementItem, SectionTitle } from "./styled";
import { CompanyIntro } from "../../common/components/company-intro";
import OpportunityInformation from "../../common/components/opportunity-information";
import { IOpportunityFetchResponse, IUserPostulation } from "../../common/constants/app.dto";
import OpportunityClosed from "../../common/components/postulation-response/opportunity-closed";
import { useGradeList } from "../../common/hooks/useGradeList";
import { useSpecialtyList } from "../../common/hooks/useSpecialtyList";

interface OpportunityProps { }

export const Opportunity = (props: OpportunityProps) => {
  const { isLoading, isSuccess, isError, opportunityData: data } = useOpportunity();
  const [suscription, opportunityData] = data || [];

  return (
    <OpportunityContainer>
      <div className="content">
        {(() => {
          if (isLoading)
            return <LoadingPage />;
          if (isSuccess && opportunityData?.status !== "ACTIVE")
            return <OpportunityClosed/>;
          if (isSuccess && opportunityData && suscription)
            return <OpportunityContent opportunity={opportunityData} postulation={suscription} />
          if (isError)
            return <ErrorPage />;
        })()}
      </div>
    </OpportunityContainer>
  );
}

interface OpportunityContentProps {
  opportunity: IOpportunityFetchResponse;
  postulation: IUserPostulation;
}

const OpportunityContent = ({opportunity, postulation}: OpportunityContentProps) => {

  const { data: gradeList } = useGradeList();
  const { data: specialtyList } = useSpecialtyList();

  function getGradeById(id: string) {
    const item = gradeList?.graduations.find(item => item.id === id);

    return item;
  };

  function getSpecialtyById(id: String) {
    const item = specialtyList?.speacialtyList.find(item => item.id === id);

    return item;
  }

  return (
    <section>
      <CompanyIntro
        jobName={opportunity.name}
        avatarUrl={opportunity.company.logoImageUrl}
        companyName={opportunity.company.name}
      />

      <OpportunityInformation
        address={opportunity.address.address}
        typeWorkId={opportunity.typeWorkTimeId}
        typeWorkTimeId={opportunity.typeWorkId}
      />

      <SectionTitle>{textChooser("txt180")}</SectionTitle>
      <OpportunityDescription>{opportunity.description}</OpportunityDescription>

      <SectionTitle>{textChooser("txt182")}</SectionTitle>
      <OpportunityDescription>{opportunity.functionDescription}</OpportunityDescription>

      <SectionTitle>{textChooser("txt177")}</SectionTitle>
      
      <ul>
        <li>{textChooser("txt184")}</li>
        {opportunity.skills.map((item, index) =>
          <RequirementItem key={`skill-${index}`}>
            <Dot /><strong>{item.name}</strong>
          </RequirementItem>
        )}
      </ul>

      <ul>
        <li>{textChooser("txt186")}</li>
        {opportunity!.studies.map((item, index) =>
          <RequirementItem key={`${item.graduationId}-${index}`}>
            <Dot /><strong>{getGradeById(item.graduationId.toString())?.name}</strong>
            {getSpecialtyById(item.careerId.toString())?.name}
          </RequirementItem>
        )}
      </ul>

      <ul>
        <li>{textChooser("txt188")}</li>
        <RequirementItem>
          <Dot />{textChooser("txt190")}:
          <strong>{opportunity.experiences[0].name}</strong>
        </RequirementItem>
        <RequirementItem>
          <Dot />{textChooser("txt192")}:
          <strong>
            {(() => {
              const { min, max } = opportunity.yearsExperience;
              if (min === max)
                return `${min} Año${min! === 1 ? '' : 's'}`;
              return `${min} - ${max} Años`;
            })()}
          </strong>
        </RequirementItem>
        <RequirementItem>
          <Dot />{textChooser("txt104")}:
          <strong>{opportunity.sectors.map(_ => _.name).join(", ")}</strong>
        </RequirementItem>
        <RequirementItem>
          <Dot />{textChooser("txt102")}:
          <strong>{opportunity.areas.map(_ => _.name).join(", ")}</strong>
        </RequirementItem>
      </ul>

      <ul hidden={!opportunity.technicalKnowledge.length}>
        <li>{textChooser("txt168")}</li>
        {opportunity.technicalKnowledge.map((item, index) =>
          <RequirementItem key={`technicalKnowledge-${index}`}>
            <Dot /><strong>{item.name} -</strong>
            {levelExpertise.filter(_ => _.value === item.value)[0].label}
          </RequirementItem>
        )}
      </ul>

      <ul hidden={!opportunity.technicalKnowledgeIt.length}>
        <li>{textChooser("txt194")}</li>
        {opportunity.technicalKnowledgeIt.map((item, index) =>
          <RequirementItem key={`technicalKnowledgeIt-${index}`}>
            <Dot /><strong>{item.name} -</strong>
            {levelExpertise.filter(_ => _.value === item.value)[0].label}
          </RequirementItem>
        )}
      </ul>

      <ul hidden={!opportunity.languages.length}>
        <li>{textChooser("txt196")}</li>
        {opportunity.languages.map((item, index) =>
          <RequirementItem key={`languages-${index}`}>
            <Dot /><strong>{item.name} -</strong>
            {levelExpertise.filter(_ => _.value === item.value)[0].label}
          </RequirementItem>
        )}
      </ul>


      {(opportunity?.workEquipment || opportunity?.availability ||
        opportunity?.availabilityTravel || opportunity?.mobility
      ) && (
          <div className="description-block others">
            <SectionTitle>{textChooser("txt202")}</SectionTitle>
            <ul>
              {opportunity?.workEquipment && <li>{textChooser("txt204")}</li>}
              {opportunity?.availability && <li>{textChooser("txt206")}</li>}
              {opportunity?.availabilityTravel && <li>{textChooser("txt208")}</li>}
              {opportunity?.mobility && <li>{textChooser("txt210")}</li>}
            </ul>
          </div>
        )}

      {!!opportunity.benefits?.length && (
        <div className="description-block benefits">
          <SectionTitle>{textChooser("txt151")}</SectionTitle>
          <ul>
            {opportunity.benefits.map((b) =>
              <li key={b.name}>{b.name}</li>
            )}
          </ul>
        </div>
      )}

      {opportunity.wage.showIn && (
        <p className="text sizeMd">
          {textChooser("txt198")}:
          <strong style={{ marginLeft: '10px' }}>
            <NumericFormat
              value={opportunity.wage.min}
              displayType={'text'}
              thousandSeparator={true}
              prefix={'S/'}
            />
            {" - "}
            <NumericFormat
              value={opportunity.wage.max}
              displayType={'text'}
              thousandSeparator={true}
              prefix={'S/'}
            />
          </strong>
        </p>
      )}

      <div style={{ marginTop: 40 }}>
        <ButtonApplyJob {...postulation} />
      </div>
    </section>
  )
}